// Export types
export type {
  Claim,
  ClaimInvoice,
  ClaimStatus,
  ClaimsFilters,
  EInvoiceSubmission,
  ClaimsAnalytics as ClaimsAnalyticsType,
  ClaimStatusGroup,
  ClaimInsuranceGroup,
  ClaimTrendPoint,
  ClaimTotals,
} from "./Claims.types";

// Export constants
export {
  CLAIM_STATUS_OPTIONS,
  CLAIM_TIMELINE_STEPS,
  getStatusColor,
  getStatusLabel,
  getSubmissionStatusColor,
  getSubmissionStatusLabel,
  isSubmissionInProgress,
} from "./Claims.constants";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { ClaimsLoading, ClaimDetailLoading, ClaimsAnalyticsLoading } from "./Claims.loading";

// Loadable components
export const ClaimsLoadable = lazy(() => import("./Claims"));
export const ClaimDetailLoadable = lazy(() => import("./ClaimDetail"));
export const ClaimsAnalyticsLoadable = lazy(() => import("./ClaimsAnalytics/ClaimsAnalytics"));

// Claims component with lazy loading
export const Claims = (props: any) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<ClaimsLoading />}>
        <ClaimsLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

// ClaimDetail component with lazy loading
export const ClaimDetail = (props: any) => {
  return (
    <ErrorBoundary fallback={<ClaimDetailLoading />}>
      <Suspense fallback={<ClaimDetailLoading />}>
        <ClaimDetailLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

// ClaimsAnalytics component with lazy loading
export const ClaimsAnalytics = (props: any) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<ClaimsAnalyticsLoading />}>
        <ClaimsAnalyticsLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
